import { render } from "./Footer.vue?vue&type=template&id=7976ef06"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\younes.zahzouh\\Desktop\\AdexIntegration\\integration\\Frontend\\guest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__